import { isAndroid, isBrowser, isIE, isIOS, isMacOs, isMobile, isWindows } from "react-device-detect";
export const useDevices = () => {
    return {
        isComputer: isBrowser,
        isMobile: isMobile,
        isMac: isMacOs,
        isWindows: isWindows,
        isAndroid: isAndroid,
        isIOS: isIOS,
        isIE: isIE,
    };
};
//# sourceMappingURL=useDevices.js.map